import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { cc } from '../../modules/styles';

import './Modal.css';

function Modal({
  children,
  onCloseRequest,
  forImage = false,
  forGallery = false,
  closeOnBackdrop = true,
  className,
  fullscreen = true,
  ariaLabelledBy,
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    dialog.focus();
    return () => dialog.close();
  }, []);

  return (
    <dialog
      ref={dialogRef}
      tabIndex={-1}
      className={cc('ModalDialog', fullscreen ? 'fullscreen' : '', className)}
      data-image={forImage || undefined}
      data-gallery={forGallery || undefined}
      aria-labelledby={ariaLabelledBy}
      onCancel={onCloseRequest}
    >
      {closeOnBackdrop && (
        <div className="backdrop" aria-hidden="true" onClick={onCloseRequest} />
      )}
      <div className="content">{children}</div>
    </dialog>
  );
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onCloseRequest: PropTypes.func.isRequired,
  closeOnBackdrop: PropTypes.bool,
  className: PropTypes.string,
  fullscreen: PropTypes.bool,
  ariaLabelledBy: PropTypes.string,
};

export default Modal;
